import { useLocation, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import './EccentricNav.css';
import logo from '../favicon.png';
import navIcon1 from '../assets/img/github.svg';
import navIcon2 from '../assets/img/linkedin.svg';
import navIcon3 from '../assets/img/resume.svg';

// Radical navigation: floating vertical rail with magnetic indicator.
// Keeps exact same link text and targets as original NavBar.
export const EccentricNav = () => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [theme, setTheme] = useState(() => (typeof window !== 'undefined' && localStorage.getItem('theme')) || 'dark');
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (typeof document !== 'undefined') {
      if (theme === 'light') {
        document.documentElement.setAttribute('data-theme', 'light');
      } else {
        document.documentElement.removeAttribute('data-theme');
      }
      localStorage.setItem('theme', theme);
    }
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === 'dark' ? 'light' : 'dark');

  const items = [
    { type: 'route', to: '/', label: 'Home' },
    { type: 'ext', href: 'https://piano.billy-chiu.com/', label: 'Piano' },
    { type: 'route', to: '/resume', label: 'Resume' },
    { type: 'ext', href: 'https://cube.billy-chiu.com/', label: 'cfop' }
  ];

  const active = location.pathname === '/resume' ? 'Resume' : location.pathname === '/' ? 'Home' : '';

  return (
    <nav className={`eccentric-nav ${scrolled ? 'nav-scrolled' : ''}`} aria-label="Primary">
      <div className="nav-inner glass-surface gradient-ring">
        <div className="brand" title="Home">
          <Link to='/'><img src={logo} alt="Logo" /></Link>
        </div>
        <div className="nav-controls">
          <ul className="nav-links" role="menubar">
            {items.map((item) => (
              <li key={item.label} role="none" className={active === item.label ? 'active' : ''}>
                {item.type === 'route' ? (
                  <Link role="menuitem" to={item.to} className="nav-pill">
                    <span className="label">{item.label}</span>
                  </Link>
                ) : (
                  <a role="menuitem" href={item.href} target="_blank" rel="noopener noreferrer" className="nav-pill">
                    <span className="label">{item.label}</span>
                  </a>
                )}
              </li>
            ))}
          </ul>
          <div className="nav-actions">
            <div className="social-cluster" aria-label="Social links">
              <a href="https://github.com/13illydakid" target="_blank" rel="noopener noreferrer"><img src={navIcon1} alt="GitHub" /></a>
              <a href="https://www.linkedin.com/in/chiu-billy" target="_blank" rel="noopener noreferrer"><img src={navIcon2} alt="LinkedIn" /></a>
              <a href="/Billy_Chiu_Resume.pdf" target="_blank" rel="noopener noreferrer"><img src={navIcon3} alt="Resume" /></a>
            </div>
            <button
              type="button"
              aria-label="Toggle color theme"
              aria-pressed={theme === 'light'}
              onClick={toggleTheme}
              className="theme-toggle nav-pill"
            >
              {theme === 'dark' ? 'Light' : 'Dark'}
            </button>
          </div>
        </div>
        {/* <div className="cta-wrap">
          <a href="#personal-bios" className="cta-btn"><span>Get to Know Me.</span></a>
        </div> */}
      </div>
    </nav>
  );
};
